// The result is rendered via v-html, so escape untrusted markup first. `&` before `<`/`>` avoids double-encoding.
const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const processMarkdown = (text: string) => {
  let processed = escapeHtml(text);
  processed = processed.replace(/###/g, "");
  processed = processed.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  return processed;
};
